module.exports = __webpack_public_path__ + "static/business-adventures-6ce6df001e4222aff9e818b93395ce05.jpg";